/**
 * A Composition Time To Sample Entry
 *
 * @group ISOBMFF
 *
 * @beta
 */
export type CompositionTimeToSampleEntry = {
	sampleCount: number;
	sampleOffset: number;
};
